var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "p-5" },
    [
      _c("h1", { staticClass: "mb-5" }, [
        _vm._v("MarketSignals® Prescriptive Data Analysis Summary")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("h2", [_vm._v("Customer File Match Counts")]),
      _vm._v(" "),
      _c("chart-grid", {
        attrs: {
          "chart-wrapper-class": "col-lg-6",
          charts: _vm.chartData.fileAnalysis,
          "charts-associated-data": _vm.chartData.fileAnalysisAssociated
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "mb-0", class: _vm.filterAlertClass },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.filterStatusMessage) }
              }),
              _vm._v("\n                Adjust this in "),
              _c(
                "router-link",
                {
                  staticClass: "alert-link",
                  attrs: { to: { params: { tab: "settings", section: null } } }
                },
                [_vm._v("Settings")]
              ),
              _vm._v(".\n            ")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("chart-grid", {
        attrs: {
          "chart-wrapper-class": "col-lg-6",
          charts: _vm.chartData.overviewData
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "newspaper-columns mb-5", attrs: { "data-columns": "2" } },
      [
        _c("p", [
          _vm._v(
            "The MarketSignals Prescriptive Data Analysis (PDA) gives you an interactive view of your customer through the lens of the most powerful consumer database available, MarketSignals Data.  It’s created by appending over 2000 MarketSignals attributes to your customer file, then indexing each of the attributes to a baseline built from the attributes of the average US consumer."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The attributes that are most significant in your customer file are those that index higher than the baseline."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Each tab represents a different type of data, with about 75% of them available only from MarketSignals. A best practice for reading the PDA is to start with this Executive Summary page to see the top demographics, interests, and propensities. From there move to the detailed demographic, interest, and automotive pages to understand what your customers look like, their overall financial picture, and what they drive."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "After that, with a basic understanding of who your clients are, dig into their engagement with brands. Under the CoCo tab are several Signals packages with powerful brand and market propensities. These pages give you a clear picture of the brands and business categories your customers are most likely to be interested in."
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col" }, [
      _c("h2", [_vm._v("Your Data at a Glance")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }